import React, { ReactNode } from 'react';

import './styles/filters-card.scss'

interface Props {
    children: ReactNode
}

function FiltersCard({children, title}) {
    return (
        <div className='filters-card'>
            <h5 className="filters-card__title">
                { title }
            </h5>
            <div>
                { children }
            </div>
        </div>
    )
}

export default FiltersCard